<template>
  <div
    class="reload-circle-progress"
    :style="{width:size+'px',height:size+'px'}"
  >
    <svg
      class="donut"
      viewBox="1.6 1.6 16.8 16.8"
    >
      <circle
        class="donutbg"
        cx="10"
        cy="10"
        r="8"
      />
      <circle
        class="stroke"
        :class="{primary:primary}"
        :style="{strokeDashoffset: strokeLength}"
        cx="10"
        cy="10"
        r="8"
      />
    </svg>
  </div>
</template>
<script>
export default {
  name: "WsReloadCircleProgress001",
  props: {
    range: {
      type: Number,
      default: 0,
    },
    size: {
      type: Number,
      default: 48,
    },
    primary: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    strokeLength() {
      let el = -51 - (51 / 100) * this.range;
      return el;
    },
  },
};
</script>